import { useManagerStore } from '../../../../../store/use-manager-store';
import { useLang } from '../../../../../hooks/use-lang';
import { validate } from '../../../../../helpers/validate';
import { isValidEmail, isValidPhone } from '../../../../../helpers/regexp';

export const useProfile = () => {
  const {
    isLoadingFetch,
    handleSaveManagerProfile,
    handleResetManagerProfile,
    managerProfile,
    saveManagerProfile,
  } = useManagerStore();

  const { t } = useLang();

  const handleSubmit = () => {
    const isValid = validate({
      surname: { rule: () => !!managerProfile?.last_name },
      name: { rule: () => !!managerProfile?.first_name },
      country: { rule: () => !!managerProfile?.country },
      region: { rule: () => !!managerProfile?.area },
      city: { rule: () => !!managerProfile?.city },
      phone: { rule: () => isValidPhone(managerProfile?.phone) },
      email: { rule: () => isValidEmail(managerProfile?.email) },
    });
    if (!isValid) return;
    handleSaveManagerProfile()
  };

  const handleCancel = () => {
    handleResetManagerProfile();
  };

  const name = `${saveManagerProfile?.first_name || ''} ${saveManagerProfile?.last_name} `;

  return {
    isLoadingFetch,
    handleSubmit,
    handleCancel,
    t,
    name,
    email: saveManagerProfile?.email,
    role: managerProfile?.role,
  };
};
